import { useTranslation, Trans } from "react-i18next";

import d1 from '../../img/About/d1.svg'
import d2 from '../../img/About/d2.svg'
import d3 from '../../img/About/d3.svg'

function DiscoverOur () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative z-50">
            <div className="w-full h-[40px] xl:h-[60px] bg-[#131313]"></div>
            <div className="w-full h-[40px] xl:h-[60px] rounded-t-[40px] xl:rounded-t-[60px] bg-white mt-[-40px] xl:mt-[-60px]"></div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-[80px]">
                <p className="manrope text-[24px] xl:text-[48px] font-[500] leading-[1.2] text-[#000000]">{t('about.3')}</p>
                <div className="flex flex-col xl:flex-row gap-[20px] justify-between mt-[60px]">
                    <div className="flex flex-col xl:border-l border-[#13131380] xl:pl-[40px]">
                        <img src={d1} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <p className="text-[#131313] manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('about.4')}</p>
                        <p className="xl:max-w-[316px] roboto font-[300] text-[12px] xl:text-[14px] mt-[10px] xl:mt-[20px] text-[#000000B2]">{t('about.5')}</p>
                    </div>
                    <div className="flex flex-col xl:border-l border-[#13131380] xl:pl-[40px]">
                        <img src={d2} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <p className="text-[#131313] manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('about.6')}</p>
                        <p className="xl:max-w-[316px] roboto font-[300] text-[12px] xl:text-[14px] mt-[10px] xl:mt-[20px] text-[#000000B2]">{t('about.7')}</p>
                    </div>
                    <div className="flex flex-col xl:border-l border-[#13131380] xl:pl-[40px]">
                        <img src={d3} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" alt="" />
                        <p className="text-[#131313] manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[30px]">{t('about.8')}</p>
                        <p className="xl:max-w-[316px] roboto font-[300] text-[12px] xl:text-[14px] mt-[10px] xl:mt-[20px] text-[#000000B2]">{t('about.9')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DiscoverOur;